import { Dialog, Grid } from '@material-ui/core';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { VoidIcon } from '../../icons';
import formatCurrency from '../../utils/formatCurrency';
import { Amount, Container, Description, StyledButton, Title } from './style';

type VoidDialogProps = {
  amount: number;
  open: boolean;
  onCancel?: () => void;
  onSubmit: () => void;
};

const VoidDialog: FC<VoidDialogProps> = (props) => {
  const { amount, open, onCancel, onSubmit } = props;
  const { t } = useTranslation();

  const handleSubmit = (): void => {
    // eslint-disable-next-line no-alert
    const isOk = window.confirm(t('dialog.void_confirm_message'));
    if (isOk) {
      onSubmit();
    }
    onCancel();
  };

  return (
    <Dialog open={open}>
      <Container>
        <VoidIcon />
        <div>
          <Title>{t('dialog.void')}</Title>
          <Description>{t('dialog.void_desc')}</Description>
        </div>
        <Amount>
          <span>{t('request_refund.amount')}</span>
          <span>PHP {formatCurrency(amount)}</span>
        </Amount>
        <Grid container justify="space-between" spacing={1}>
          <Grid item xs={6}>
            <StyledButton size="small" variant="outlined" onClick={onCancel}>
              {t('dialog.cancel')}
            </StyledButton>
          </Grid>
          <Grid item xs={6}>
            <StyledButton
              color="primary"
              size="small"
              variant="contained"
              onClick={handleSubmit}
            >
              {t('dialog.confirm')}
            </StyledButton>
          </Grid>
        </Grid>
      </Container>
    </Dialog>
  );
};

export default VoidDialog;
